import { Paper } from "@mui/material";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";

const CustomPaper = styled(Paper)(({ theme, alignItems, removePadding }) => ({
    backgroundColor: "white",
    ...theme.typography.body2,
    padding: !removePadding ? theme.spacing(0.5, 1.2, 0, 1.2) : 0,
    boxShadow: "none",
    textAlign: alignItems || "center",
    color: theme.palette.text.secondary,
    ...theme.applyStyles("dark", {
        backgroundColor: "#1A2027",
    }),
}));

CustomPaper.propTypes = {
    alignItems: PropTypes.string,
};

export default CustomPaper;
